const gbTrackerCore = require('./lib/gb-tracker-core');

module.exports = gbTrackerCore;


//////////////////
// WEBPACK FOOTER
// ./~/gb-tracker-client/index.js
// module id = 172
// module chunks = 0